module.exports = __webpack_public_path__ + "static/media/birthdate.97fca42e.svg";